import { useState } from 'react';

import { useMountEffect } from '@react-hookz/web';

import { UNIFIED } from 'src/app/analytics/analyticsEvents';
import { Card } from 'src/app/components/Elements/Card';
import RadioCardItem from 'src/app/components/Elements/Card/RadioCardItem';
import StandardPage from 'src/app/components/Elements/Page/Standard';
import Spinner from 'src/app/components/Elements/Spinner';
import { Typography } from 'src/app/components/Elements/Typography';
import IdVerificationRequired from 'src/app/components/Pages/Checkout/IdVerificationRequired/container';
import { useSegmentTrack } from 'src/app/hooks/useSegmentTrack';
import { accountLoadEverything } from 'src/app/state/actions';
import { bffFetchCart, setPickupStationAsDeliveryMethod } from 'src/app/state/actions/cart';
import { fetchCheckoutPickupStations } from 'src/app/state/actions/checkoutPickupStations';
import {
  getAccount,
  getAccountIsFetching,
  getCheckoutPickupStations,
  getCheckoutPickupStationsIsFetching,
  getCurrentCartId,
  getCurrentCartUUID,
} from 'src/app/state/selectors';
import { useDispatch, useSelector } from 'src/app/state/store';

export const PickupStationSelect = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const isFetchingAccount = useSelector(getAccountIsFetching);
  const account = useSelector(getAccount);

  const cartId = useSelector(getCurrentCartId);
  const cartUUID = useSelector(getCurrentCartUUID);

  const pickupStations = useSelector(getCheckoutPickupStations);
  const isFetchingPickupStations = useSelector(getCheckoutPickupStationsIsFetching);
  const dispatch = useDispatch();
  const dispatchUpdateCartAndPushNextCheckoutState = async (deliveryAddressId: string) => {
    await dispatch(setPickupStationAsDeliveryMethod(deliveryAddressId));
  };

  useMountEffect(() => {
    const dispatchLoadCartAndPickupStations = async (cartId: string) => {
      if (cartId && !cartUUID) await dispatch(bffFetchCart(cartId));
      await dispatch(fetchCheckoutPickupStations());
    };

    if (!isFetchingAccount && !account) dispatch(accountLoadEverything());

    if (!isFetchingPickupStations && !pickupStations) dispatchLoadCartAndPickupStations(cartId);
  });

  useSegmentTrack(UNIFIED.viewPickupLocation);

  if (isFetchingAccount || isFetchingPickupStations || isSubmitting) {
    <StandardPage title="Choose your pickup location">
      <Spinner centered />
    </StandardPage>;
  }

  return (
    <StandardPage title="Choose your pickup location">
      <div>
        <IdVerificationRequired />
        <Card>
          {pickupStations?.map((pickupStation, index) => {
            const { id, name, address, addressTwo, city, state, zipCode } = pickupStation;
            return (
              <RadioCardItem
                data_cy={`pickup-station-address-${index}`}
                key={id}
                isActive={false}
                onClick={() => {
                  dispatchUpdateCartAndPushNextCheckoutState(pickupStation?.id);
                  setIsSubmitting(true);
                }}
              >
                <Typography variant={'bodyBold'} marginBottom={'s2'}>
                  {name}
                </Typography>
                <Typography variant="body" color="capsuleGreen60">
                  {address}
                </Typography>
                {addressTwo && (
                  <Typography variant="body" color="capsuleGreen60">
                    {addressTwo}
                  </Typography>
                )}
                <Typography variant="body" color="capsuleGreen60">
                  {`${city}, ${state} ${zipCode}`}
                </Typography>
              </RadioCardItem>
            );
          })}
        </Card>
      </div>
    </StandardPage>
  );
};
